import React from 'react';
import { findOccurrenceForDate, LocalizedEventData } from '@carlito/bookito-client';
import humanizeDuration, { SupportedLanguage } from 'humanize-duration';
import { applyTimeOfDate } from '@carlito/date-utils';
import { isEventAllDay } from './helper';
import { Trans } from 'react-i18next';
import { formatPrice } from '@carlito/api';

export type Props = {
  event: LocalizedEventData;
  date: Date;
  activeLanguage: SupportedLanguage;
  isAllDay?: boolean;
  overallDuration?: number | null;
};

function EventInfo({ event, date: onDate, overallDuration, activeLanguage, isAllDay }: Props) {
  const stringifiedDuration = humanizeDuration(overallDuration ?? 0, {
    language: 'shortDe',
    // fallbacks: ['en'],
    languages: {
      shortDe: {
        y: () => 'y',
        mo: () => 'mo',
        w: () => 'w',
        d: () => 'd',
        h: () => 'h',
        m: () => 'm',
        s: () => 's',
        ms: () => 'ms',
      },
    },
    units: ['h', 'm'],
    maxDecimalPoints: 0,
    delimiter: ' ',
  } as any);

  const price = event.basePrice?.amount || 0;
  return (
    <div className="flex justify-between items-start gap-2">
      {price && price !== null ? (
        <div>
          <p className="font-bold text-base">
            <Trans i18nKey="price" />
          </p>
          <p className="text-4xl font-bold">{formatPrice(price, activeLanguage)}</p>
        </div>
      ) : (
        <div />
      )}
      {overallDuration && (
        <div className="text-right bookito-form__duration">
          <p className="font-bold text-base">
            <Trans i18nKey="duration" />
          </p>
          {isAllDay ? (
            <p className="text-4xl font-normal">
              <Trans i18nKey="all-day" />
            </p>
          ) : (
            <p className="text-4xl font-normal">{stringifiedDuration}</p>
          )}
        </div>
      )}
    </div>
  );
}

export default EventInfo;
